<div class="layout-container">

    <img src="assets/logo.svg" class="logo" alt="Ludico" />

    <h1>Ludico</h1>
    <h2>Turning every gathering into a game night.</h2>

    <main class="main-content">

        <!-- MIND LINK -->

        <a class="game-badge">

            <div class="game-icon mind-link"></div>

            <div class="game-info">
                <div class="game-header">
                    <h3 class="game-title">Mind Link</h3>
                    <div class="game-category primary">POPOULAR</div>
                </div>
                <span class="game-players">3 PLAYERS</span>
                <p class="game-description">Sync your thoughts and build the perfect clue.</p>
                <button class="game-cta" routerLink="/mind-link">Play Now →</button>
            </div>

        </a>

        <!-- IMPOSTOR -->

        <a class="game-badge">

            <div class="game-icon impostor"></div>

            <div class="game-info">
                <div class="game-header">
                    <h3 class="game-title">Impostor</h3>
                    <div class="game-category secondary">MISTERY</div>
                </div>
                <span class="game-players">3+ PLAYERS</span>
                <p class="game-description">Trust no one, blend in, and unmask the liar.</p>
                <button class="game-cta" routerLink="/impostor">Play Now →</button>
            </div>
            
        </a>

    </main>

    <footer class="home-footer">
        <p class="copyright">© 2026 Ludico. All rights reserved.</p>
        <p class="info-links">
            <!-- <a routerLink="/about">About</a> • -->
            <a routerLink="/legal-information">Privacy & Cookie Policy</a>
        </p>
    </footer>

</div>
